import axios from "axios";
import { baseUrl } from "../util";

// Flow 42 - End of Life Stage Form Data
export const getEndOfLife42LCA = ({
  productId,
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/end-of-life-42-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching end of life 42:", error);
      setData(null);
    });
};

export const updateEndOfLife42LCA = ({
  productId,
  products_waste_code_eak,
  is_product_classified_as_hazardous_waste,
  portion_of_hazardous_toxic_radioactive_waste_weight_percent,
  material_recycling_possible,
  specify_which_parts_recyclable,
  energy_recovery_possible,
  restrictions_recommendations_material_energy_recovery,
  specify_restrictions,
  system_boundary,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/end-of-life-42-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      products_waste_code_eak: products_waste_code_eak || null,
      is_product_classified_as_hazardous_waste: is_product_classified_as_hazardous_waste || "No",
      portion_of_hazardous_toxic_radioactive_waste_weight_percent: portion_of_hazardous_toxic_radioactive_waste_weight_percent || null,
      material_recycling_possible: material_recycling_possible || "No",
      specify_which_parts_recyclable: specify_which_parts_recyclable || null,
      energy_recovery_possible: energy_recovery_possible || "No",
      restrictions_recommendations_material_energy_recovery: restrictions_recommendations_material_energy_recovery || "No",
      specify_restrictions: specify_restrictions || null,
      system_boundary: system_boundary || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "End of Life 42 data updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating end of life 42:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update end of life 42 data",
          icon: "error",
          button: "OK",
        });
      }
    });
};

// Flow 42 Totals
export const getEndOfLife42Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/end-of-life-42-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching end of life 42 totals:", error);
      setTotals(null);
    });
};

// Flow 42.1 - Disassembly, deconstruction and demolition
export const getAllFlow42_1LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-42-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 42.1:", error);
      setObjects([]);
    });
};

export const addFlow42_1LCA = ({
  productId,
  name_deconstruction_sorting_processes,
  describe_the_process,
  what_is_added_material_energy,
  quantity_per_fu_material_energy,
  disposal_method,
  quantity_per_fu_disposal,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-42-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_deconstruction_sorting_processes: name_deconstruction_sorting_processes || null,
      describe_the_process: describe_the_process || null,
      what_is_added_material_energy: what_is_added_material_energy || null,
      quantity_per_fu_material_energy: quantity_per_fu_material_energy || 0,
      disposal_method: disposal_method || null,
      quantity_per_fu_disposal: quantity_per_fu_disposal || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 42.1 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 42.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 42.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow42_1LCA = ({
  productId,
  rowId,
  name_deconstruction_sorting_processes,
  describe_the_process,
  what_is_added_material_energy,
  quantity_per_fu_material_energy,
  disposal_method,
  quantity_per_fu_disposal,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-42-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_deconstruction_sorting_processes: name_deconstruction_sorting_processes || null,
      describe_the_process: describe_the_process || null,
      what_is_added_material_energy: what_is_added_material_energy || null,
      quantity_per_fu_material_energy: quantity_per_fu_material_energy || 0,
      disposal_method: disposal_method || null,
      quantity_per_fu_disposal: quantity_per_fu_disposal || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 42.1 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 42.1:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 42.1 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow42_1LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-42-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 42.1 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 42.1:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 42.1 item",
        icon: "error",
        button: "OK",
      });
    });
};

// Flow 42.2 - Resource Potential Form Data
export const getFlow42_2LCA = ({
  productId,
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-42-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching flow 42.2:", error);
      setData(null);
    });
};

export const updateFlow42_2LCA = ({
  productId,
  designed_for_disassembly,
  dfd_list_parts,
  special_measures_health_environment,
  describe_special_measures,
  removal_destructive_only,
  describe_destructive_removal,
  disassembly_not_on_site,
  difficult_removal_firmly_attached,
  describe_difficult_removal,
  mechanical_effort_required,
  can_be_removed_by_hand,
  describe_disassembly_process,
  difficulty_in_disassembling_percent,
  chemical_cement_bonding,
  self_adhesive_water_soluble,
  cast_in_place,
  welded_in_place,
  riveted_in_place,
  nailed_in_place,
  screwed_in_place,
  bolted_in_place,
  friction_assembly,
  click_assembly,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-42-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      designed_for_disassembly: designed_for_disassembly || "No",
      dfd_list_parts: dfd_list_parts || null,
      special_measures_health_environment: special_measures_health_environment || "No",
      describe_special_measures: describe_special_measures || null,
      removal_destructive_only: removal_destructive_only || "No",
      describe_destructive_removal: describe_destructive_removal || null,
      disassembly_not_on_site: disassembly_not_on_site || "No",
      difficult_removal_firmly_attached: difficult_removal_firmly_attached || "No",
      describe_difficult_removal: describe_difficult_removal || null,
      mechanical_effort_required: mechanical_effort_required || "No",
      can_be_removed_by_hand: can_be_removed_by_hand || "No",
      describe_disassembly_process: describe_disassembly_process || null,
      difficulty_in_disassembling_percent: difficulty_in_disassembling_percent || null,
      chemical_cement_bonding: chemical_cement_bonding || "No",
      self_adhesive_water_soluble: self_adhesive_water_soluble || "No",
      cast_in_place: cast_in_place || "No",
      welded_in_place: welded_in_place || "No",
      riveted_in_place: riveted_in_place || "No",
      nailed_in_place: nailed_in_place || "No",
      screwed_in_place: screwed_in_place || "No",
      bolted_in_place: bolted_in_place || "No",
      friction_assembly: friction_assembly || "No",
      click_assembly: click_assembly || "No",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 42.2 data updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 42.2:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 42.2 data",
          icon: "error",
          button: "OK",
        });
      }
    });
};

